import { SkeletonLine } from '@dynamika-shared/ui/Skeleton/Skeleton';
import { twMerge } from '@dynamika-shared/utils/twMerge';
import { FC } from 'react';

type CellValuesCortegeProps = {
  loading?: boolean;
  loadingLength?: number;
  loadingWidth?: number;
  cortege?: [string, number][];
  className?: string;
  labelClassName?: string;
  valueClassName?: string;
};

export const CellValuesCortege: FC<CellValuesCortegeProps> = ({
  loading,
  loadingLength,
  loadingWidth = 170,
  cortege = [],
  className,
  labelClassName,
  valueClassName,
}) => {
  if (loading) {
    return (
      <div>
        {[...Array(loadingLength)].map((_, index) => {
          if (index > 0) {
            return (
              <SkeletonLine
                key={'skeleton' + index}
                length={loadingWidth}
                className='mt-1'
              />
            );
          }
          return <SkeletonLine key={'skeleton' + index} length={170} />;
        })}
      </div>
    );
  }
  return (
    <div>
      {cortege.map(([label, value], i) => (
        <div
          key={label + i}
          className={twMerge(
            'flex items-center text-1424 mini:text-1216 font-medium',
            className
          )}
        >
          <div
            className={twMerge('w-[4.9rem] text-spanishGray', labelClassName)}
          >
            {label}:
          </div>
          <div className={valueClassName}>{value}</div>
        </div>
      ))}
    </div>
  );
};
